module.exports = __webpack_public_path__ + "img/T1D_xh15.fd5d57aa.png";